import { ReducerCreators } from '@reduxjs/toolkit';
import { CampaignTemplatesState } from './initial';

export const reducers = (create: ReducerCreators<CampaignTemplatesState>) => ({
  loadCampaignTemplates: create.reducer((state) => state),
});
